module.exports = __webpack_public_path__ + "img/logo.b5add89e.png";